export default "__VITE_ASSET__CxYrXBim__"